import { createSlice } from '@reduxjs/toolkit';

import { shareTest } from '../thunk/shareTest';

const shareTestSlice = createSlice({
  name: 'shareTest',
  initialState: {
    data: {},
    error: null,
    loading: false,
  },
  reducers: {
    resetShareTest: (state) => {
      state.data = {};
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(shareTest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(shareTest.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(shareTest.rejected, (state, action) => {
        state.error = action.payload || action.error?.message;
        state.loading = false;
      });
  },
});

export const { resetShareTest } = shareTestSlice.actions;

export default shareTestSlice.reducer;
